import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field } from 'react-final-form';

import {
  Col,
  IconButton,
  TextField,
} from '@folio/stripes/components';

import UserSelection from '../user-selection';

import {
  ICONS,
  ASSIGNED_USER_ID,
  ASSIGNED_USER_NAME,
  ASSIGNED_USER_ID_INITIAL_VALUE,
  ASSIGNED_USER_NAME_INITIAL_VALUE,
} from '../../../constants';
import {
  formatCurrentUserFromStripes,
  validateRequiredField,
  getFirstLastUserName,
  handleFormDataChange,
} from '../../../utils';

const SelectUserLookUp = ({
  isObjectDataFormat,
  id,
  name,
  change,
  stripes,
  noTeams,
}) => {
  const selectUser = (user) => {
    const changeValues = {
      [ASSIGNED_USER_ID]: user.id,
      [ASSIGNED_USER_NAME]: getFirstLastUserName(user),
    };

    handleFormDataChange(changeValues, isObjectDataFormat, change);
  };

  const clearUser = () => {
    const changeValues = {
      [ASSIGNED_USER_ID]: ASSIGNED_USER_ID_INITIAL_VALUE,
      [ASSIGNED_USER_NAME]: ASSIGNED_USER_NAME_INITIAL_VALUE,
    };

    handleFormDataChange(changeValues, isObjectDataFormat, change);
  };

  const renderClearButton = () => (
    <IconButton
      icon={ICONS.TIMES_CIRCLE_SOLID}
      size="small"
      onClick={clearUser}
    />
  );

  return (
    <Col
      data-test-assign-user
      sm={4}
    >
      <Field
        disabled
        component={TextField}
        endControl={renderClearButton()}
        hasClearIcon={false}
        id={id}
        label={<FormattedMessage id="ui-task-list.task.field.assignUser" />}
        name={name}
        required={!noTeams}
        validate={!noTeams && validateRequiredField}
      />
      <UserSelection
        hasAssignCurrent
        assignCurrentLabelId="ui-task-list.user.assignMe"
        onCurrentUserSelect={() => selectUser(formatCurrentUserFromStripes(stripes.user.user))}
        onUserSelect={selectUser}
      />
    </Col>
  );
};

SelectUserLookUp.propTypes = {
  change: PropTypes.func.isRequired,
  stripes: PropTypes.shape({
    user: PropTypes.shape({
      user: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
  id: PropTypes.string,
  isObjectDataFormat: PropTypes.bool,
  name: PropTypes.string,
  noTeams: PropTypes.bool,
};

SelectUserLookUp.defaultProps = {
  isObjectDataFormat: false,
  noTeams: false,
  id: ASSIGNED_USER_NAME,
  name: ASSIGNED_USER_NAME,
};

export default SelectUserLookUp;
